export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_09.e3990817.jpg";